/* eslint-disable no-param-reassign */
import apis from '../apis/apis'

const capPhatVanBangProcessor = {}
const controllerName = 'CapPhatVanBang'

capPhatVanBangProcessor.getByKhoaThi = async ({
  khoaThiId,
  skip,
  take,
  donViDangKyDuThiId = 0,
  heDaoTaoId = 0,
  hinhThucDaoTaoId = 0,
  name = '',
}) => {
  const rs = await apis[controllerName].GetVanBangDaDuyetByKhoaThiId({
    param: `/${khoaThiId}?skip=${skip}&take=${take}&donViDangKyDuThiId=${donViDangKyDuThiId}&heDaoTaoId=${heDaoTaoId}&hinhThucDaoTaoId=${hinhThucDaoTaoId}&name=${name}`,
  })
  return rs.isSuccess ? rs.data : { skip, take, values: [], total: 0 }
}

capPhatVanBangProcessor.upsert = async (data) => {
  const submitData = { ...data, phanHois: undefined }
  let rs
  const request = {}
  const formdata = new FormData()
  formdata.append('file', data.fileDinhKemCapPhat)
  data.fileDinhKemCapPhat = undefined
  Object.keys(submitData).forEach((key) => {
    const value = submitData[key]
    if (value !== null) {
      formdata.append(key, value)
    }
  })
  request.formData = true
  request.data = formdata
  if (submitData.id) {
    rs = await apis[controllerName].UpdateWithFile({
      method: 'post',
      responseType: 'text',
      ...request,
    })
  }
  return rs
}
capPhatVanBangProcessor.delete = async ({ id, noiDung }) => {
  const rs = await apis[controllerName].Delete({
    method: 'post',
    responseType: 'text',
    param: `/${id}/${noiDung}`,
  })
  return rs
}
capPhatVanBangProcessor.getLyDoHuy = async (id) => {
  const rs = await apis[controllerName].GetLyDoHuy({
    method: 'get',
    param: `/${id}`,
  })
  return rs.isSuccess ? rs.data : []
}
export default capPhatVanBangProcessor
